import { SET_SOURCES_LIST_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCES_LIST_SETTINGS, {
  searchTerm: '',
  statusFilter: 'all',
  sortOrder: 'name'
})
